import axios from "../axios"
import apiUrls from "../urls"

export default {
    fetchCandidates(data) {
        return axios.post(apiUrls.fetchCandidates, data);
    },
    submitReviewResult(data) {
        return axios.post(apiUrls.submitReviewResult, data);
    },
    reviewDetails(data) {
        return axios.post(apiUrls.reviewDetails, data);
    },
    fetchCandidatesByUniversity(data) {
        return axios.post(apiUrls.fetchCandidatesByUniversity, data);
    },
    fetchCandidatesByAffiliation(data) {
        return axios.post(apiUrls.fetchCandidatesByAffiliation, data);
    },
    fetchCandidatesByName(data) {
        return axios.post(apiUrls.fetchCandidatesByName, data);
    },
    fetchCandidatesByJobID(data) {
        return axios.post(apiUrls.fetchCandidatesByJobID, data);
    },
    fetchCandidatesByEmail(data) {
        return axios.post(apiUrls.fetchCandidatesByEmail, data);
    },
    fetchCandidatesByLastName(data) {
        return axios.post(apiUrls.fetchCandidatesByLastName, data);
    },
    screeningLogin(data) {
        return axios.post(apiUrls.screeningLogin, data);
    },
    updateReviewStatus(data) {
        return axios.post(apiUrls.updateReviewStatus, data);
    },
    sendReviewInvitation(data) {
        return axios.post(apiUrls.sendReviewInvitation, data);
    },
    screenMemberLogin(data) {
        return axios.post(apiUrls.screenMemberLogin, data);
    },
    currentReviewDetails(data) {
        return axios.post(apiUrls.currentReviewDetails, data);
    },
    fetchStatusTimeline(data) {
        return axios.post(apiUrls.fetchStatusTimeline, data);
    },
    screenMemberLogout(authenticationType) {
        return axios.get(authenticationType === "cas" ? apiUrls.screenMemberLogout : apiUrls.ssoScreenMemeberLogout);
    },
    recommendForDecline(data) {
        return axios.post(apiUrls.recommendForDecline, data);
    },
    getRequestDeclineList(data) {
        return axios.post(apiUrls.getRequestDeclineList, data);
    },
    declineRecommendOperation(data) {
        return axios.post(apiUrls.declineRecommendOperation, data);
    },
    fetchAccessRight() {
        return axios.get(apiUrls.fetchAccessRight);
    },
    externalLogin(data) {
        return axios.post(apiUrls.externalLogin, data);
    },
    startResetPwdScreening(data) {
        return axios.post(apiUrls.resetPasswordScreening, data)
    },
    updatePasswordScreening(data) {
        return axios.post(apiUrls.updatePasswordScreening, data)
    },
    //e check list
    fetchECheckList(data) {
        return axios.post(apiUrls.fetchECheckList, data)
    },
    fetchECheckListByUsername(data){
        return axios.post(apiUrls.fetchECheckListByUsername, data)
    },
    createECheckList(data) {
        return axios.post(apiUrls.createECheckList, data)
    },
    lockECheckList(data) {
        return axios.post(apiUrls.lockECheckList, data)
    },
    unLockECheckList(data) {
        return axios.post(apiUrls.unLockECheckList, data)
    },
    updateECheckList(data){
        return axios.post(apiUrls.updateECheckList, data)
    },
    eCheckListFetchAccessRight(data){
        return axios.post(apiUrls.eCheckListFetchAccessRight, data)
    },
    eCheckListUploadFile (data, onUploadProgress) {
        console.log('Calling upload file function');
        let formData = new FormData()
        formData.append("file", data.file)
        var currentHeader = {}
        if(data.referee !== "" && data.refereeToken !== ""){
            currentHeader = {
                "Content-Type": "multipart/form-data",
                "Authorization": "Bearer " + data.refereeToken
            }
        }
        else{
            currentHeader = {
                "Content-Type": "multipart/form-data"
            }
        }
        // console.log(formData);
        return axios.post(apiUrls.eCheckListUploadFile, formData, {
            headers: currentHeader,
            params: {
                type: data.type,
                kind: data.kind,
                index: data.index,
                referee: data.referee,
                cid: data.cid
            },
            onUploadProgress,
            timeout: 5 * 60 * 1000
        });
    },
    eCheckListUploadVideo (data, onUploadProgress) {
        console.log('Calling upload video function');
        let formData = new FormData()
        formData.append("file", data.file)
        return axios.post(apiUrls.eCheckListUploadVideo, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                "Process-Data": false,
            },
            params: {
                type: data.type,
                kind: data.kind,
                index: data.index,
                cid: data.cid
            },
            onUploadProgress,
            timeout:15 * 60 * 1000
        },);
    },
}
